<template>
  <div>
    <a-row>
      <a-col :span="24"><top-banel/></a-col>
    </a-row>
    <a-row>
      <a-col :span="6">
        <node-tree ref="NodeTree" v-on:nodeIdChange="nodeIdChange"/>
      </a-col>
      <a-col :span="18">
        <div>
          <!-- 展示框 -->
          <div id="showArticleDiv">
            <div id="showArticleDivButton" style="display:none"><!-- 各类按钮 -->
              <table style="width: 100%;border: 0px">
                <tr>
                  <td align="left">
                    <a-button type="danger" @click="removeSelectArticle">删除当前版本</a-button> &nbsp;&nbsp;&nbsp;&nbsp;
                    <a-switch default-checked checked-children="分享中" un-checked-children="私有" @change="shareArticle" v-model="shareButton"/>
                    <span id="sharedUrl"></span>
                  </td>
                  <td align="right">
                    <a-button type="primary" @click="editArticleContent">修改内容</a-button> &nbsp;&nbsp;&nbsp;&nbsp;
                    <a-button type="primary" @click="editHtml" class="button-color-sunset">修改HTML</a-button>
                    <a-select v-model="currentArticleHistoryVersion" @change="userHisContent">
                      <a-select-option v-for="ah in articleHistories" :key="ah.id">
                        {{ ah.ymd }}
                      </a-select-option>
                    </a-select>
                    <a-button type="primary" onclick="document.getElementById('dragUploadField').style.display='block';" class="button-color-green"><a-icon type="upload" /> 上传文件</a-button>
                    <!-- 这是普通的上传按钮，改为允许拖拽以后，就不再使用了
                    <a-upload
                      :show-upload-list="false"
                      name="file"
                      :multiple="true"
                      :action="uploadActionDefault"
                      :headers="uploadHeaders"
                      @change="uploadFile"
                    >
                      <a-button> <a-icon type="upload" />上传文件</a-button>
                    </a-upload>
                    -->
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div align="right" style="width: 100%" id="dragUploadField">
                      <a-upload-dragger
                        :show-upload-list="false"
                        name="file"
                        :multiple="true"
                        :action="uploadActionDefault"
                        :headers="uploadHeaders"
                        @change="uploadFile"
                      >
                        <p class="ant-upload-drag-icon">
                          <a-icon type="inbox" />
                        </p>
                        <p class="ant-upload-text">
                          Click or drag file to this area to upload
                        </p>
                        <p class="ant-upload-hint">
                          Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                          band files
                        </p>
                      </a-upload-dragger>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <!-- 附件框 -->
            <input type="hidden" id="willRemoveFileId" value=""/>
            <div id="uploadedFiles" align="left"></div>
            <iframe :src="articleContentFrame" frameborder='0' style='width:100%' id="articleContentFrameNode"></iframe>
          </div>
          <!-- ///////////////////////// -->
          <!-- 编辑框 -->
          <div id="editArticleDiv" style="display: none">
            <div align="right"><!-- 各类按钮 -->
              <a-button type="primary" @click="saveArticleContent">保存</a-button>
              <a-button type="primary" class="button-color-green" @click="reloadArticleContent">返回</a-button>
            </div>
            <div><textarea id="htmlDiv" style="width:100%" v-model="articleContent" @change="removeFileById"></textarea></div>
            <div align="left" id="editorDiv"></div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import Vue from "vue";
  import NodeTree from './NodeTree';
  import TopBanel from './TopBanel';
  import axios from "axios";
  import E from 'wangeditor';

  export  default {
    "name":"Dashboard",
    data(){
      return{
        nodeId:"",
        token:(Vue.prototype.$global.SERVER_TOKEN==null||""==Vue.prototype.$global.SERVER_TOKEN)?this.$route.query.token:Vue.prototype.$global.SERVER_TOKEN,
        uploadActionDefault:Vue.prototype.$global.SERVER_URL+'/wiki/file/upload',
        articleContentFrame:"",
        articleContent:"Loading...",
        uploadHeaders:{},
        editContentOrHtml:'content',
        editor:new E('#editorDiv'),
        currentArticleHistoryVersion:"",
        selectArticleId:'',
        willRemoveFileId:'',
        articleHistories:[],
        shareButton:true
      }
    },
    mounted() {
      this.resizeArticlePanel();
      this.editor.config.withCredentials = true;
      this.editor.config.uploadImgShowBase64 = true;  // 使用base64传图
      // this.editor.config.uploadFileName = 'file';
      // this.editor.config.uploadImgServer = this.uploadActionDefault; // 上传图片服务器地址，不和base64兼容
      this.editor.create();
      window.setInterval(this.removeFileById, 500);
    },
    methods:{
      removeFileById(){
        if(document.getElementById('willRemoveFileId').value == '' || this.willRemoveFileId == document.getElementById('willRemoveFileId').value) return;
        this.willRemoveFileId = document.getElementById('willRemoveFileId').value;
        let cfm = confirm("即将删除文件且无法恢复，确定删除？");
        if(!cfm){document.getElementById('willRemoveFileId').value='';this.willRemoveFileId='';return;}
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/file/delete', {
          "id":this.willRemoveFileId
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            document.getElementById('willRemoveFileId').value = '';
            this.willRemoveFileId = '';
            this.nodeIdChange(this.nodeId)
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });

      },
      removeSelectArticle(){
        if(this.selectArticleId=='' || this.selectArticleId == null){
          alert("当前没有在展示中的内容");
          return;
        }
        let cfm = confirm("删除将不可恢复，确定要删除选中版本？")
        if(!cfm) return;
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/article/delete', {
          "id":this.selectArticleId
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.nodeIdChange(this.nodeId)
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      userHisContent(value){
        this.selectArticleId = value;
        document.getElementById('articleContentFrameNode').src=Vue.prototype.$global.SERVER_URL+"/wiki/article/loading";
        this.articleContentFrame = Vue.prototype.$global.SERVER_URL+"/wiki/article/show-content-id?token="+this.token+"&id="+value+"&timestamp="+new Date().getTime();
      },
      uploadFile(info){
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          this.$message.success(`${info.file.name} file uploaded successfully`);
          this.reloadUploadedFiles();
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} file upload failed.`);
        }
      },
      reloadUploadedFiles(){
        axios.get(Vue.prototype.$global.SERVER_URL+'/wiki/file/uploaded-files',{headers:this.uploadHeaders}).then((response) => {
          let dt = response.data;
          if(dt.success){
            let ht = "";
            if(dt.data.length > 0){
              ht += "<div style='height:1px;width: 100%;background-color: #f1f1f1'></div><div style='padding: 10px'>";
              ht += "<div style='float:left;margin-right:20px;margin-bottom:10px'><a href='javascript:void(0)' style='color:green' onclick='this.style.display=\"none\";let atgs = document.getElementsByTagName(\"a\");for(let i=0; i<atgs.length; i++) if(atgs[i].getAttribute(\"data-atype\")==\"D\") atgs[i].style.display=\"inline\";'>管理文件</a></div>"
              for(let i=0; i<dt.data.length; i++){
                ht += "<div style='float:left;margin-bottom:10px'>";
                ht += "<a href='"+Vue.prototype.$global.SERVER_URL+"/wiki/file/download?id="+dt.data[i].id+"' target='_blank'>♖";
                ht += dt.data[i].filename;
                ht += "</a>";
                ht += " <a href='javascript:void(0)' style='display: none;color:red' data-atype='D' onclick='document.getElementById(\"willRemoveFileId\").value=\""+dt.data[i].id+"\"'>[删]</a>";
                ht += "</div>";
                if(i<dt.data.length-1) ht += "<div style='float:left;margin-bottom:10px;margin-left:5px;margin-right:5px;'>┃</div>\r\n"
              }
              ht += "<div style='clear:both'></div>"
              ht += "</div><div style='height:1px;width: 100%;background-color: #f1f1f1'></div>";
            }
            document.getElementById("uploadedFiles").innerHTML=ht
            this.resizeArticlePanel();
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      editHtml(){
        let nodeTemp = this.nodeId[0].length>1?this.nodeId[0]:this.nodeId;
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/article/show', {
          "id":nodeTemp
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.editContentOrHtml = 'html';
            this.articleContent = dt.article.content;
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
        document.getElementById("showArticleDiv").style.display="none";
        document.getElementById("editArticleDiv").style.display="block";
        document.getElementById("htmlDiv").style.display="block";
        document.getElementById("editorDiv").style.display="none";
      },
      shareArticle(){ // 分享或取消分享
        let nodeTemp = this.nodeId[0].length>1?this.nodeId[0]:this.nodeId;
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/article/share', {
          "id":nodeTemp
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success && dt.menu['shared']){
            let sharedUrl = Vue.prototype.$global.SERVER_URL+"/wiki/article/show-shared/"+nodeTemp;
            document.getElementById('sharedUrl').innerHTML = "<a target='_blank' href='"+sharedUrl+"'>"+sharedUrl+"</a>"
            this.shareButton = true;
          }else if(dt.success && !dt.menu['shared']){
            document.getElementById('sharedUrl').innerHTML = '';
            this.shareButton = false;
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      editArticleContent() {
        this.resizeArticlePanel();
        let nodeTemp = this.nodeId[0].length>1?this.nodeId[0]:this.nodeId;
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/article/show', {
          "id":nodeTemp
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.editContentOrHtml = 'content';
            this.articleContent = dt.article.content;
            this.editor.txt.html(dt.article.content);
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
        document.getElementById("showArticleDiv").style.display="none";
        document.getElementById("editArticleDiv").style.display="block";
        document.getElementById("htmlDiv").style.display="none";
        document.getElementById("editorDiv").style.display="block";
      },
      saveArticleContent(){
        if(this.editContentOrHtml == 'content') this.articleContent = this.editor.txt.html();
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/article/save', {
          "id":this.nodeId[0],
          "content":this.articleContent
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.reloadArticleContent()
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      reloadArticleContent() {
        this.nodeIdChange(this.nodeId);
      },
      nodeIdChange(nid) {
        this.nodeId = nid;
        if(nid == '-1' || nid == '') document.getElementById("showArticleDivButton").style.display="none";
        else document.getElementById("showArticleDivButton").style.display="block";
        document.getElementById('articleContentFrameNode').src=Vue.prototype.$global.SERVER_URL+"/wiki/article/loading";
        this.articleContentFrame = Vue.prototype.$global.SERVER_URL+"/wiki/article/show-content?token="+this.token+"&id="+this.nodeId+"&timestamp="+new Date().getTime();
        this.resizeArticlePanel();
        this.uploadHeaders = {"token":this.token,"saveType":1,"nodeId":nid};
        this.editor.config.uploadImgHeaders = {"token":this.token,"saveType":0,"nodeId":nid};
        this.reloadUploadedFiles(nid);
        this.createArticleHistorySelecter(nid);
        this.refreshSharedInfo();
        document.getElementById("showArticleDiv").style.display="block";
        document.getElementById("editArticleDiv").style.display="none";
        document.getElementById('dragUploadField').style.display='none';
      },
      refreshSharedInfo(){ // 初始化分享按钮
        let nodeTempId = this.nodeId;
        if(nodeTempId[0].length > 1) nodeTempId = nodeTempId[0];
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/menu/detail',{"id":nodeTempId}, {headers:{"token":this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            if(dt.menu['shared']){
              this.shareButton = true;
              let sharedUrl = Vue.prototype.$global.SERVER_URL+"/wiki/article/show-shared/"+nodeTempId;
              document.getElementById('sharedUrl').innerHTML = "<a target='_blank' href='"+sharedUrl+"'>"+sharedUrl+"</a>"
            }else{
              this.shareButton = false;
              document.getElementById('sharedUrl').innerHTML = ""
            }
          }else{
            alert(">>"+dt.code);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      createArticleHistorySelecter(nid){
        if(nid.length == 0 || nid[0]=='-1') {
          this.selectArticleId='';
          return;
        }
        //从左侧菜单栏点击，这个会变成数组，从传参的方式又是字符串，需要统一成字符串型
        if(nid[0].length > 1) nid = nid[0];
        // 构建历史版本
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/article/history',{"id":nid}, {headers:{"token":this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            if(dt.articles.length == 0){
              this.articleHistories = [];
              this.currentArticleHistoryVersion='没有历史数据';
              this.selectArticleId='';
              return;
            }
            let articleHistoriesTemp = [];
            for(let i=0; i<dt.articles.length; i++){
              articleHistoriesTemp.push({"id":dt.articles[i]['_id'], "ymd":dt.articles[i]['ymd']});
            }
            this.selectArticleId = articleHistoriesTemp[0]["id"];
            this.articleHistories=articleHistoriesTemp;
            this.currentArticleHistoryVersion=this.articleHistories[0]['ymd'];
            this.resizeArticlePanel();
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      resizeArticlePanel(){
        const acfn = document.getElementById('articleContentFrameNode');
        const sab = document.getElementById('showArticleDivButton');
        const uf = document.getElementById('uploadedFiles');
        acfn.style.height = (document.documentElement.clientHeight-sab.clientHeight-uf.clientHeight-60)+"px";
        acfn.style.overflow = "auto";
        document.getElementById('editorDiv').style.height = (document.documentElement.clientHeight-sab.clientHeight-60)+"px";
        document.getElementById('htmlDiv').style.height = (document.documentElement.clientHeight-sab.clientHeight-60)+"px";
        this.editor.config.height = document.documentElement.clientHeight-sab.clientHeight-120;
      }
    },
    components: {NodeTree, TopBanel}
  };
</script>



// WEBPACK FOOTER //
// src/components/personal/Dashboard.vue